import React from 'react';
import Banner from '../components/Banner';
import Footer from '../components/Footer';
import CheckoutTransferencia from '../components/CheckoutTransferencia';

const CheckoutTransferenciaPage: React.FC = () => {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Banner />
      <div style={{ flex: 1 }}>
        <CheckoutTransferencia />
      </div>
      <Footer />
    </div>
  );
};

export default CheckoutTransferenciaPage;
